import { render, staticRenderFns } from "./display-product.vue?vue&type=template&id=9e5925ca&scoped=true&"
import script from "./display-product.vue?vue&type=script&lang=js&"
export * from "./display-product.vue?vue&type=script&lang=js&"
import style0 from "./display-product.vue?vue&type=style&index=0&id=9e5925ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5925ca",
  null
  
)

export default component.exports